import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=ad875a86&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad875a86')) {
      api.createRecord('ad875a86', component.options)
    } else {
      api.reload('ad875a86', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=ad875a86&", function () {
      api.rerender('ad875a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/login2/views/Register.vue"
export default component.exports